"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCombinedRefs = useCombinedRefs;

var _react = require("react");

function assignRef(ref, value) {
  if (ref == null) return;

  if (typeof ref === 'function') {
    ref(value);
    return;
  }

  try {
    // eslint-disable-next-line no-param-reassign
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value '".concat(value, "' to ref '").concat(ref, "'"));
  }
}

function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return (0, _react.useCallback)(function (node) {
    refs.forEach(function (ref) {
      assignRef(ref, node);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}